import { createStore } from "vuex";

export default createStore({
  state: {
    items: [
   
    ],
    cart: [],
  },

  getters: {
    total: (state) => {
      if (state.cart.length > 0) {
        return state.cart
          .map((item) => item.totalPrice)
          .reduce((total, amount) => total + amount);
      } else {
        return 0;
      }
    },
  },

  mutations: {
    addToCart(state, payload) {
      let addedItem = state.items.find((item) => item.id === payload.id);

      let existItem = state.cart.find((item) => item.id == payload.id);

      if (existItem) {
        existItem.productQuantity++;
        existItem.totalPrice += addedItem.price;
      } else {
        return state.cart.push(payload);
      }
    },

    removeFromCart(state, item) {
      let index = state.cart.indexOf(item);
      state.cart.splice(index, 1);
    },
  },
  actions: {},
});
